<template>
  <div>
    <div class="wrap message-list-wrap">
      <div class="top-header">
        <h3>my 코칭</h3>
      </div>
      <div class="body-wrap">
        <incMenu></incMenu>
        <div class="message-list" v-if="chat.length">
          <div class="message" v-for="(item, index) in chat" :key="index" @click="message(item.userIdx)">
            <p>
              {{ item.userName }}님과 대화 <span v-if="item.unreadCount > 0">{{ item.unreadCount }}</span>
            </p>
          </div>

          <!-- <div class="message" @click="message()">
                        <p>김소연님과 대화 <span>20</span></p>
                    </div>
                    <div class="message" @click="message()">
                        <p>정수빈님과 대화</p>
                    </div>
                    <div class="message" @click="message()">
                        <p>1:1 문의 <span>20</span></p>
                    </div> -->
        </div>
        <div v-else>
          <p class="txt-center mt-20">채팅 목록이 없습니다.</p>
        </div>
        <div class="message-list">
          <div class="message" @click="message(-1)">
            <p>
              1:1 문의 <span>{{ unreadReplyCount }}</span>
            </p>
          </div>
        </div>
      </div>
      <incTab></incTab>
    </div>
  </div>
</template>
<script>
import incMenu from "@/components/inc/inc_menu.vue";
import incTab from "@/components/inc/inc_tab.vue";
export default {
  name: "coaching_message",
  data: () => ({
    chat: [],
    unreadReplyCount: 0,
  }),
  components: {
    incMenu,
    incTab,
  },
  mounted() {
    this.getChatList();
    this.getQnaCount();
  },
  methods: {
    getQnaCount() {
      this.axios
        .get(`/qna/count/${this.$store.state.userInfo.userIdx}`)
        .then((res) => {
          if (res.data.success) {
            this.unreadReplyCount = res.data.contentinfo.unreadReplyCount;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getChatList() {
      let params = {
        userIdx: this.$store.state.userInfo.userIdx,
      };
      this.axios
        .get("/chat/list", { params })
        .then((res) => {
          if (res.data.success) {
            this.chat = res.data.contentinfo.chatList;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    message(userIdx) {
      this.$router.push({ name: "message", params: { userIdx: userIdx } });
    },
  },
};
</script>
